import { FC, useContext } from "react";
import { Flex } from "@otrium/core";
import { AppCtx } from "src/contexts/app.context";
import { LogoRounded } from "src/icons/LogoRounded";
import { TrustpilotCustom } from "src/molecules/TrustpilotBox";
import { Wrapper } from "./LogoRoundedHeader.styled";
const LogoRoundedHeader: FC = () => {
  const { locale } = useContext(AppCtx);
  return (
    <>
      <Wrapper />
      <Flex maxWidth="1120px" mx={[0, 0, 0, "auto", "auto"]}>
        <Flex
          pt={3}
          px={[5, 5, 5, 5, 5, 0]}
          alignItems="center"
          maxWidth="1120px"
          justifyContent="space-between"
          sx={{
            position: "absolute",
            zIndex: 999,
            width: "100%",
          }}
        >
          <LogoRounded />
          <TrustpilotCustom locale={locale} small />
        </Flex>
      </Flex>
    </>
  );
};
export default LogoRoundedHeader;
